import axios from './axios'
import { handleResponse } from './util'

interface AutoCampaignDisplay {
  id: number
  merchant_name: string
  textable_members: number
  enabled: boolean
}

export const autoCampaignAPI = {
  /**
   * GET all auto-campaigns that belong to this advertiser
   * @param {number} advertiserId
   * @param {number} currentPage
   */
  getAutoCampaigns(
    advertiserId: number,
    currentPage: number
  ): Promise<AutoCampaignDisplay[]> {
    return axios
      .get(`/auto_campaigns`, {
        params: { brand_id: advertiserId, page: currentPage },
      })
      .then(handleResponse)
  },

  /**
   * GET details for a specific auto-campaign with id
   * @param {number} advertiserId
   * @param {number} autoCampaignId
   */
  getAutoCampaign(
    advertiserId: number,
    autoCampaignId: number
  ): Promise<unknown> {
    return axios.get(`/auto_campaigns/${autoCampaignId}`, {
      params: { brand_id: advertiserId }
    }).then(handleResponse)
  }
}